import { useAutomationTemplates } from '../../useAutomationTemplates';
import { TemplatesTable } from './TemplatesTable';
import { TemplatesTableError } from './TemplatesTableError';
import { TemplatesTableLoading } from './TemplatesTableLoading';

export function TemplatesManager() {
  const { data: templatesData, isLoading, error } = useAutomationTemplates();

  const templates = templatesData?.templates || [];

  if (isLoading) {
    return <TemplatesTableLoading />;
  }

  if (error) {
    return <TemplatesTableError error={error} />;
  }

  return <TemplatesTable templates={templates} />;
}
